import { memo, useId } from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = memo(function Input({ label, error, className, ...props }: InputProps) {
  const generatedId = useId();
  const id = props.id || generatedId;
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div className="space-y-1.5">
      {label && <label htmlFor={id} className="text-sm font-medium text-foreground">{label}</label>}
      <input
        id={id}
        aria-invalid={Boolean(error)}
        aria-describedby={errorId}
        className={cn(
          'flex h-11 w-full rounded-lg border border-input bg-white px-3 py-2 text-sm text-slate-950 outline-none transition-colors placeholder:text-slate-500 focus:border-primary focus:ring-2 focus:ring-primary/20',
          error && 'border-destructive focus:border-destructive focus:ring-destructive/30',
          className
        )}
        {...props}
      />
      {error && <p id={errorId} className="text-xs text-destructive">{error}</p>}
    </div>
  );
});
